export class GetHiredDetail{
  loadId:number = undefined;
  vehicleId:number = undefined;
  trailerId:number = undefined;
  driverId:number = undefined;

}